import React from "react";
import { socialMediaLinks } from "portfolio";

interface SocialMediaProps {
  // Fired when any social link is activated (click or keyboard). Lets a parent
  // react without wrapping the anchors in another interactive element.
  onLinkClick?: () => void;
}

const SocialMedia: React.FC<SocialMediaProps> = ({ onLinkClick }) => {
  const socialLinks = [
    {
      name: "GitHub",
      url: socialMediaLinks.github,
      icon: "fab fa-github",
      show: !!socialMediaLinks.github,
    },
    {
      name: "LinkedIn",
      url: socialMediaLinks.linkedin,
      icon: "fab fa-linkedin-in",
      show: !!socialMediaLinks.linkedin,
    },
    {
      name: "X",
      url: socialMediaLinks.x,
      icon: "fa-brands fa-x-twitter",
      show: !!socialMediaLinks.x,
    },
    {
      name: "Email",
      url: `mailto:${socialMediaLinks.gmail}`,
      icon: "fas fa-envelope",
      show: !!socialMediaLinks.gmail,
    },
    {
      name: "GitLab",
      url: socialMediaLinks.gitlab,
      icon: "fab fa-gitlab",
      show: !!socialMediaLinks.gitlab,
    },
    {
      name: "Instagram",
      url: socialMediaLinks.instagram,
      icon: "fab fa-instagram",
      show: !!socialMediaLinks.instagram,
    },
  ];

  return (
    <div className="flex flex-wrap gap-3">
      {socialLinks
        .filter((link) => link.show)
        .map((link) => (
          <a
            key={link.name}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="relative flex items-center justify-center w-12 h-12 sm:w-11 sm:h-11 transition-colors duration-200 border rounded-md group bg-bg-surface border-border text-text-muted hover:border-accent/30 hover:text-accent hover:shadow-glow-sm"
            aria-label={link.name}
            title={link.name}
            onClick={onLinkClick}
          >
            <i className={`${link.icon} text-sm`} aria-hidden="true" />

            {/* Tooltip */}
            <span className="absolute px-2 py-1 text-[10px] font-mono text-bg-primary transition-opacity transform -translate-x-1/2 bg-text-primary rounded opacity-0 pointer-events-none -bottom-8 left-1/2 group-hover:opacity-100 group-focus-visible:opacity-100 whitespace-nowrap z-50">
              {link.name}
            </span>
          </a>
        ))}
    </div>
  );
};

export default SocialMedia;
